// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1bRyS","loaderOuter":"PageOverlayLoader_loaderOuter__J6NSp"};